import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { TableLoader } from "../../../Common/ShimmerLoader";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import {
  getAllOverallScvTrips,
  getFourTimeTripsInnerReportTransaction,
  getFourTimeTripsInnerReportTotalTransaction,
  getMoreThanFourTimeTripsInnerReportTotalTransaction,
  getMoreThanFourTimeTripsInnerReportTransaction,
  getOneTimeTripsInnerReportTransaction,
  getThreeTimeTripsInnerReportTransaction,
  getTwoTimeTripsInnerReportTransaction,
  getOneTimeTripsInnerReportTotalTransaction,
  getTwoTimeTripsInnerReportTotalTransaction,
  getThreeTimeTripsInnerReportTotalTransaction,
} from "../../../Apis/scvReports/overallScvTripsApi";
import {
  AllTransferStationTransactions,
  AllTransferStationTotalTransactions,
} from "../../../Apis/TransferStationReport/allTransferStationTransactionApi";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import isGHMC from "../../../Common/helper/helpar";

const SCVOverallTrips = () => {
  let dataPerPage = 5;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [scvTripsData, setScvTripsData] = useState([]);
  const [fromDate, setFromDate] = useState(getStartOfCurrentDate());
  const [toDate, setToDate] = useState(getCurrentDateTime());
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  // Fetch SCV trips data
  const isProd = isGHMC();

  const handleTotalTripsClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllTransferStationTransactions(
          fromDate,
          toDate,
          row.zoneId,
          "2",
          "" // Pass empty string for circleId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {

        response = await AllTransferStationTransactions(
          fromDate,
          toDate,
          "",
         "", // Pass circleId,
          "2",
          "",
          row.transferStationId
        );
      }
      navigate("/view-overall-trips", { state: response.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalTripsClickColumn = async () => {
    setIsOptionsLoading(true);
    try {
      // Call a different API for the total of the column
      const response = await AllTransferStationTotalTransactions(
        fromDate,
        toDate,
        "2",
        "",
        ""
      );
  
      navigate("/view-overall-trips", { state: response.data });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedAtTsClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllTransferStationTransactions(
          fromDate,
          toDate,
          "",
         "", // Pass circleId,
          "2",
          "",
          row.transferStationId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {

        response = await AllTransferStationTransactions(
          fromDate,
          toDate,
          "",
         "", // Pass circleId,
          "2",
          "",
          row.transferStationId
        );
      }
      navigate("/view-overall-trips", { state: response.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleReportedAtTsTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      // Call a different API for the total of the column
      const response = await AllTransferStationTotalTransactions(
        fromDate,
        toDate,
        "2",
        "",
       ""
      );
  
      navigate("/view-overall-trips", { state: response.data });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await getAllOverallScvTrips(fromDate, toDate);
      setScvTripsData(response.data);
    } catch (error) {
      console.error("Error fetching overall SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData(); // Call the async function immediately
  }, []);

  // useEffect(() => {
  //   fetchScvTripsData();
  // }, []);

  const handleSearch = () => {
    fetchData(); // Call fetchData when the search button is clicked
  };

  // const handleZoneClick = async (zoneId) => {
  //   fetchScvTripsData(zoneId);
  // };

  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      //   sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "5%",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      // width:'9%',
      cell: (row) => <span>{row["zoneName"]}</span>,
      //    sortable: true,
    },
    {
      name: "Circle",
      // width:'9%',
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"]}</span>,
      //    sortable: true,
    },
    {
      name: "Transfer Station",
      // width:'10%',
      selector: (row) => row["transferStationName"],
      cell: (row) => <span>{row["transferStationName"]}</span>,
      //   sortable: true,
    },
    {
      name: (
        <>
          Reported At <br />
          TS/SCTP
        </>
      ),
      width: "8%",
      selector: (row) => row["reportedAtTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleReportedAtTsTotalClick();
            } else {
              handleReportedAtTsClick(row);
            }
          }}
        >
          {row["reportedAtTS"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: "Total Trips",
      width: "8%",
      selector: (row) => row["totalTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalTripsClickColumn();
            } else {
              handleTotalTripsClick(row);
            }
          }}
        >
          {row["totalTrips"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: "Trip-1",
      width: "8%",
      selector: (row) => row["oneTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleOneTripTotalClick();
            } else {
              handleOneTripClick(row);
            }
          }}
        >
          {row["oneTrip"]}
        </span>
      ),
      //     sortable: true,
    },
    {
      name: "Trip-2",
      width: "8%",
      selector: (row) => row["twoTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTwoTripTotalClick();
            } else {
              handleTwoTripClick(row, fromDate, toDate);
            }
          }}
        >
          {row["twoTrip"]}
        </span>
      ),
      //   sortable: true,
    },
    {
      name: "Trip-3",
      width: "8%",
      selector: (row) => row["threeTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleThreeTripTotalClick();
            } else {
              handleThreeTripClick(row, fromDate, toDate);
            }
          }}
        >
          {row["threeTrip"]}
        </span>
      ),
      //     sortable: true,
    },
    {
      name: "Trip-4",
      width: "8%",
      selector: (row) => row["fourTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleFourTripTotalClick();
            } else {
              handleFourTripClick(row, fromDate, toDate);
            }
          }}
        >
          {row["fourTrip"]}
        </span>
      ),
      //     sortable: true,
    },
    {
      name: ">05 Trip",
      width: "10%",
      selector: (row) => row["moreThanFiveTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleMoreThanFourTripTotalClick();
            } else {
              handleMoreThanFourTripClick(row, fromDate, toDate);
            }
          }}
        >
          {row["moreThanFiveTrip"]}
        </span>
      ),
      //    sortable: true,
    },
  ];

  const handleOneTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      response1 = await getOneTimeTripsInnerReportTransaction(
        fromDate,
        toDate,
        "",
        "",
        "2", // Pass empty string for circleId
        row.transferStationId
      );
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOneTripTotalClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      response1 = await getOneTimeTripsInnerReportTotalTransaction(
        fromDate,
        toDate,
        "2",
        ""
      );
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleTwoTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getTwoTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          row.zoneId,
          "",
          "" // Pass empty string for circleId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getTwoTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          "",
          "", // Pass circleId,
          "2",
          row.transferStationId
        );
      }
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTwoTripTotalClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      response1 = await getTwoTimeTripsInnerReportTotalTransaction(
        fromDate,
        toDate,
        "2",
        ""
      );
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getThreeTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          row.zoneId,
          "",
          "2" // Pass empty string for circleId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getThreeTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          "",
          "", // Pass circleId,
          "2",
          row.transferStationId
        );
      }
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleThreeTripTotalClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      response1 = await getThreeTimeTripsInnerReportTotalTransaction(
        fromDate,
        toDate,
        "2",
        ""
      );
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleFourTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getFourTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          row.zoneId,
          "",
          "" // Pass empty string for circleId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getFourTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          "",
          "", // Pass circleId,
          "2",
          row.transferStationId
        );
      }
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleFourTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      response1 = await getFourTimeTripsInnerReportTotalTransaction(
        fromDate,
        toDate,
        "2",
        ""
      );
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getMoreThanFourTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          row.zoneId,
          "",
          "" // Pass empty string for circleId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getMoreThanFourTimeTripsInnerReportTransaction(
          fromDate,
          toDate,
          "",
          "", // Pass circleId,
          "2",
          row.transferStationId
        );
      }
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMoreThanFourTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      response1 = await getMoreThanFourTimeTripsInnerReportTotalTransaction(
        fromDate,
        toDate,
        "2",
        ""
      );
      navigate("/view-overall-trips", { state: response1.data });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const exportToExcel = () => {
  //   const dataWithSerialNumber = scvTripsData.map((item, index) => ({
  //     ...item,
  //     's.no': index + 1,
  //   }));
  //   const filteredData = dataWithSerialNumber.map(item => ({
  //     's.no': item['s.no'],
  //     zone: item.zoneName,
  //     circle: item.circleName,
  //     TransferStationName: item.transferStationName,
  //     TotalTrips: item.totalTrips,
  //     OneTrip:item.oneTrip,
  //     TwoTrip: item.twoTrip,
  //     ThreeTrip:item.threeTrip,
  //     FourTrip: item.fourTrip,
  //     MoreThanFiveTrip: item.moreThanFiveTrip,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "SCVsOverallTripsReport");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const excelBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(excelBlob);
  //   downloadLink.download = "SCVsOverallTripsReport.xlsx";
  //   downloadLink.click();
  // };
  const option = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTimes = ` ${new Date()
    .toLocaleString("en-GB", option)
    .replace(/\//g, "/")}`;
  const exportToExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SCVs Overall Trips Reports`;
    const downloadDateTime = `Reported on: ${generationTimes},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 10); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "SCVs Overall Trips Reports", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 10); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "SCVs Overall Trips Reports"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Deployment",
      "Reported At TS/SCTP",
      "Total Trips",
      "Trip-1",
      "Trip-2",
      "Trip-3",
      "Trip-4",
      ">05 Trip",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 13) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    scvTripsData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName?? "N/A",
          item.deployment?? "N/A",
          item.reportedAtTS?? "N/A",
          item.totalTrips?? "N/A",
          item.oneTrip?? "N/A",
          item.twoTrip?? "N/A",
          item.threeTrip?? "N/A",
          item.fourTrip?? "N/A",
          item.moreThanFiveTrip?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 13) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsOverallTripsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const calculateSCVOverallTotals = (data) => {
    const totals = {
      sno: "Total",
      zoneName: "Total",
      deployment: 0,
      reportedAtTS: 0,
      totalTrips: 0,
      oneTrip: 0,
      twoTrip: 0,
      threeTrip: 0,
      fourTrip: 0,
      moreThanFiveTrip: 0,
    };

    data.forEach((row) => {
      totals.deployment += row.deployment || 0;
      totals.reportedAtTS += row.reportedAtTS || 0;
      totals.totalTrips += row.totalTrips || 0;
      totals.oneTrip += row.oneTrip || 0;
      totals.twoTrip += row.twoTrip || 0;
      totals.threeTrip += row.threeTrip || 0;
      totals.fourTrip += row.fourTrip || 0;
      totals.moreThanFiveTrip += row.moreThanFiveTrip || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateSCVOverallTotals(scvTripsData);
  const scvOverallDataWithTotal = [...scvTripsData, totalZoneRow];

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <h4 class="text-start mb-3">SCVs Overall Trips to TS/SCTP</h4>

          <div className="card">
            <div className="card-body p-3">
              <div
                className="row align-items-end"
                style={{ textAlign: "left" }}
              >
                <div className="col-md-10">
                  <div className="row">
                    <div className="col-md-3 ">
                      <label>From Date & Time:</label>
                      <input
                        type="datetime-local"
                        name="fromDate"
                        style={inputStyle}
                        className="form-control"
                        value={fromDate}
                        max={getCurrentDateTime()}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>

                    <div className="col-md-3 ">
                      <label>To Date & Time:</label>
                      <input
                        type="datetime-local"
                        name="toDate"
                        className="form-control"
                        style={inputStyle}
                        value={toDate}
                        max={getCurrentDateTime()}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>

                    <div className="col-md-3 ">
                      <button
                        className={`btn mt-4 ${
                          isProd ? "search-ghmc" : "search-swm"
                        }`}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="text-end">
                    <button
                      className="btn btn-excel ms-auto mt-3"
                      onClick={exportToExcel}
                    >
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Excel
                    </button>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <CustomDataTable
                  data={scvOverallDataWithTotal}
                  columns={scvReportColumns}
                  dataPerPage={dataPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SCVOverallTrips;

const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

const inputStyle = {
  backgroundColor: "#fff",
  height: "40px",
  // width: "250px",
  // border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const buttonStyle = {
  backgroundColor: "#E21E26",
  height: "40px",
  // minWidth: "80px",
  border: "1px solid #E2E2E2",
  marginTop: "20px",
  borderRadius: "5px",
  color: "#fff",
};
